// Shared landing-page constants.

// OAuth install link — opens Discord's app-add flow in a new tab.
export const ADD_TO_DISCORD_URL =
  "https://discord.com/oauth2/authorize?client_id=1519161404702199969";
